import React, { useState, useEffect } from "react";
import { Form, Popconfirm, Spin } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import Button from "@/common/elements/Button";
import DataTable from "@/common/elements/DataTable";
import CustomModal from "@/components/CustomModal";
import { StyledFlex, StyledSubTableContainer } from "@/common/styles";
import RulesModulesTableViewsFieldForm from "@/pages/Security/Sections/StaffGroupForms/RulesModulesTableViewsFieldForm";
import {
  fetchSecurityRuleFunctionalityList,
  fetchSecurityRuleFunctionalityById,
  createSecurityRuleFunctionality,
  updateSecurityRuleFunctionality,
  deleteSecurityRuleFunctionality,
} from "@/apis/security/securityRulesFunctionalityApi";
import { clearCurrentFunctionality } from "@/slices/securityRulesFunctionalitySlice";
import { fetchAllSecurityListOfStaff } from "@/apis/staff/staffApi";
import { setBookings } from "@/slices/bookingsSlice";
import {
  isLoggedInStaff,
  isNonEmptyVariable,
  refreshLoggedInUserSecurity,
} from "@/util/common_function";
import { v4 as uuidV4 } from "uuid";
import _ from "lodash";
import RulesModulesTableViewsFieldForm2 from "@/pages/Security/Sections/StaffGroupForms/RulesModulesTableViewsFieldForm2";
import useDialog from "@/hooks/useDialog";
import useGridColumnConfig from "@/hooks/useGridColumnConfig";

const SECURITY_RULES_FUNCTIONALITY_HEADERS = [
  { key: "entityType", text: "Entity Type" },
  { key: "moduleId", text: "Module ID" },
  { key: "subModuleId", text: "SubModule ID" },
  { key: "tableViewId", text: "TableView ID" },
  { key: "fieldName", text: "Field Name" },
  { key: "allowSetting", text: "Allow Setting" },
  { key: "denySetting", text: "Deny Setting" },
  { key: "ruleActive", text: "Rule Active" },
];

// Stable reference: a fresh `{}` literal on every render re-fires the form's
// seed effect (deps: [initialValues]) and wipes in-progress Add input whenever
// this component re-renders (e.g. any redux dispatch re-renders the parent).
const EMPTY_INITIAL_VALUES = {};

const UserInfoSecurityRulesControlling = ({ staffGroupsId, bookingsFieldsEnabled = true, startingPoint = "" }) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { showDialog } = useDialog();

  // "Config" — drag-reorder/resize columns, persisted per-user (see
  // docs/plans/grid-column-config-feature.md). Reachable from both
  // /staffing (startingPoint="Staff") and /users (startingPoint="Users") —
  // per explicit product decision, each entry point persists its own layout.
  const {
    headers,
    isConfiguring,
    configButtonLabel,
    startConfiguring,
    confirmSave,
    discardChanges,
    dataTableRef,
  } = useGridColumnConfig(
    `${startingPoint || "Staff"}:SecurityRulesFunctionality`,
    SECURITY_RULES_FUNCTIONALITY_HEADERS
  );

  // const list = useSelector((s) => s.securityRulesFunctionality.list) || [];
  const [list, setList] = useState([])
  const loadingList = useSelector((s) => s.securityRulesFunctionality.loading);
  // const functionality = useSelector((s) => s.securityRulesFunctionality.current);
  // const saving = useSelector((s) => s.securityRulesFunctionality.saving);
  // const updating = useSelector((s) => s.securityRulesFunctionality.updating);
  // const deleting = useSelector((s) => s.securityRulesFunctionality.deleting);
  const [selectedRow, setSelectedRow] = useState(null);
  const [isModalOpen, setModalOpen] = useState(false);
  const [mode, setMode] = useState("add");
  const [isLoading, setIsLoading] = useState(false);

  const { bookings } = useSelector((s) => s?.bookings);
  console.log({ bookings })

  useEffect(() => {
    if (isNonEmptyVariable(bookings?.securityRulesFunctionality)) {
      let allRules = bookings?.securityRulesFunctionality?.map((e, i) => {
        return {
          ...e,
          uuid: uuidV4(),
        }
      })
      console.log(allRules, "allRules")
      if (allRules?.length) {
        setList([...allRules])
      }
      else {
        setList([])
      }
    }
  }, [bookings]);
  useEffect(() => {
    console.log({ list })
  }, [list])
  const onRowClick = (row, index) => {
    setSelectedRow(row);
    if(index !== null && index !== undefined) {
      openEdit();
    }
  };

  const openAdd = () => {
    form.resetFields();
    dispatch(clearCurrentFunctionality());
    setMode("add");
    setIsLoading(true)
    setSelectedRow(null);
    setModalOpen(true);
  };
  useEffect(() => {
    console.log("re-render")
  })
  const openEdit = () => {
    if (!selectedRow) return;
    // form.resetFields();
    // console.log({selectedRow,functionality})
    // form.setFieldsValue(selectedRow)
    dispatch(clearCurrentFunctionality());
    dispatch(fetchSecurityRuleFunctionalityById(selectedRow.securityRulesFunctionalityID));
    setMode("edit");
    setIsLoading(true)
    setModalOpen(true);
  };
  const openDelete = () => {
    if (!selectedRow) return;
    showDialog("confirm", {
      title: "Are you sure you want to delete this record?",
      onConfirm: () => confirmDelete(),
      // onCancel: () => { setIsLoading(false) }
    });
  }
  const confirmDelete = () => {
        setIsLoading(true)

    dispatch(deleteSecurityRuleFunctionality(selectedRow.securityRulesFunctionalityID)).then(() => {
      if (isLoggedInStaff(bookings?.staffId)) {
        refreshLoggedInUserSecurity(dispatch);
      }
    });
    console.log({ selectedRow })
    let newList = _.cloneDeep(list)
    if (newList?.length) {
      newList = newList.filter((e, i) => {
        if (e.uuid != selectedRow?.uuid) {
          return e
        }
      })
      console.log({ newList })
      dispatch(
        setBookings({
          securityRulesFunctionality: [...newList],
        })
      );
    }
    setSelectedRow(null);
    setIsLoading(false)
  };

  const closeModal = () => {
    dispatch(clearCurrentFunctionality());
    setModalOpen(false);
    setIsLoading(false)
  };

  const handleSave = () => form.submit();

  const onFinish = (values) => {
    console.log({ values }, "payload")
    const payload = {
      ...values,
      dateAdded: values.dateAdded?.format("MM/DD/YYYY"),
      timeAdded: values.timeAdded?.format("HH:mm"),
      staffId: bookings?.staffId,
      ruleActive: ruleActive ? "true" : "false"
    };
    let newList = _.cloneDeep(list)
    // console.log({ payload })
    if (mode == "edit") {
      console.log({ selectedRow })
      if (newList?.length) {
        newList = newList.map((e, i) => {
          if (e.uuid == selectedRow?.uuid) {
            console.log({ ...e, ...payload }, "newList")
            return { ...e, ...payload }
          }
          return e
        })
        console.log({ newList })
      }
    }
    // console.log({ newList })

    if (mode == "add") {
      if (newList?.length == 0) {
        newList.push(payload)
        // setList([payload])
      } else {
        console.log({ payload })
        newList = [...newList, payload]
        // setList([...list, payload])
      }
    }
    console.log({ list })
    dispatch(
      setBookings({
        securityRulesFunctionality: [...newList],
      })
    );
    // const action =
    //   mode === "add"
    //     ? createSecurityRuleFunctionality(payload)
    //     : updateSecurityRuleFunctionality(payload);
    // dispatch(action).then(() => {
    //   dispatch(fetchSecurityRuleFunctionalityList(staffGroupsId));
    // });
    closeModal();

    // if (bookings?.staffId)
    //   dispatch(fetchAllSecurityListOfStaff(bookings?.staffId))
  };

  return (
    <>
      <StyledSubTableContainer marginTop="25px">
        <StyledFlex justify="space-between" align="center">
          <h2>SECURITY RULES CONTROLLING FUNCTIONALITY</h2>
          <StyledFlex gap="10px" marginBottom="5px" justify="end">
            <Button onClick={openAdd} disabled={!bookingsFieldsEnabled || isConfiguring}>Add</Button>
            <Button onClick={openEdit} disabled={!selectedRow || isConfiguring} >Details</Button>
            <Button onClick={openDelete} disabled={!selectedRow || !bookingsFieldsEnabled || isConfiguring}>Delete</Button>

            {/* Config — drag-reorder/resize columns */}
            {!isConfiguring ? (
              <Button htmlType="button" onClick={startConfiguring}>
                {configButtonLabel}
              </Button>
            ) : (
              <Popconfirm
                title="Do you want to save the current list view configuration?"
                onConfirm={confirmSave}
                onCancel={discardChanges}
                okText="Yes"
                cancelText="No"
              >
                <Button htmlType="button">{configButtonLabel}</Button>
              </Popconfirm>
            )}
          </StyledFlex>
        </StyledFlex>

        <Spin spinning={loadingList}>
          <DataTable
            headers={headers}
            draggable={isConfiguring}
            data={list || []}
            ref={dataTableRef}
            rowUniqueId="uuid"
            onRowClick={onRowClick}
            allowTableSorting
            autoResetSelection={false}
            selected={selectedRow === null}
            isAPiCallLoading={isLoading}
          />
        </Spin>
      </StyledSubTableContainer>

      {isModalOpen && (
        <CustomModal
          size="lg"
          header={mode === "add" ? "Add Rule" : "Modify Rule"}
          show={isModalOpen}
          onHide={closeModal}
          onSaveClick={handleSave}
          // confirmLoading={saving}
          backdrop={false}
          maskClosable={false}
          isDisabled={!bookingsFieldsEnabled}
        >
          <RulesModulesTableViewsFieldForm2
            form={form}
            initialValues={mode === "edit" ? selectedRow : EMPTY_INITIAL_VALUES}
            onFinish={onFinish}
            disabled={loadingList || !bookingsFieldsEnabled}
          />
        </CustomModal>
      )}
    </>
  );
};

export default UserInfoSecurityRulesControlling;
